// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail {\n  margin-top: 15px;\n  font-size: 9px;\n}", ""]);
// Exports
module.exports = exports;
